<template>
  <div class="page-debug">
    <Player class="player" v-on:player="initPlayer($event.ppPlayer)"/>
    <div>
      <div>Source 1</div>
      <input type="text" v-model="sources[0]">
      <div>Source 2</div>
      <input type="text" v-model="sources[1]">
      <div>Source 3</div>
      <input type="text" v-model="sources[2]">
      <div>Delay MS</div>
      <input type="text" v-model="delay">
      <button @click="start">Start</button>
      <button @click="stop">Stop</button>
      <button @click="clearSources">Load Default Sources</button>
      <div>Wait for load</div>
      <input type="checkbox" v-model="waitForLoad">
    </div>
  </div>
</template>

<script>
import Player from '../components/player/Player';

const S1 = '';
const S2 = '';
const S3 = '';
const STORAGE_KEY = 'cl-debug-sources';

export default {
  name: 'page-debug',
  components: {
    Player
  },
  data () {
    return {
      player: null,
      sources: [S1, S2, S3],
      delay: '500',
      waitForLoad: true,
      running: false,
      sourceIndex: 0
    };
  },
  created () {
    this.loadSources();
  },
  methods: {
    initPlayer (ref) {
      this.player = ref;
      if (this.player) {
        window.player = this.player.get();
      }
    },
    start () {
      this.saveSources();
      this.running = true;
      this.load();
    },
    stop () {
      const player = this.player.get();
      this.running = false;
      player.release();
    },

    saveSources () {
      if (window.localStorage) {
        const s = window.localStorage;
        s.setItem(STORAGE_KEY, JSON.stringify(this.sources));
      }
    },
    loadSources () {
      if (window.localStorage) {
        const s = window.localStorage;
        const data = s.getItem(STORAGE_KEY);
        if (data) {
          this.sources = JSON.parse(data);
        }
      }
    },
    clearSources () {
      if (window.localStorage) {
        const s = window.localStorage;
        s.removeItem(STORAGE_KEY);
        this.sources = [S1, S2, S3];
      }
    },
    async load () {
      if (!this.running) return;

      const player = this.player.get();
      const config = {
        source: {
          url: this.sources[this.sourceIndex]
        },
        manifest: {
          attemptParameters: {
            maxAttempts: 5
          }
        },
        autoplay: true,
        muted: true
      };

      try {
        if (this.waitForLoad) {
          console.log('Loading Source ' + this.sourceIndex + ' and wait');
          player.release();

          await player.load(config);
        } else {
          console.log('Loading Source ' + this.sourceIndex + ' and continue');
          player.release();
          player.load(config);
        }
      } catch (e) {
        console.log('Failed to start playback', e);
      }

      this.sourceIndex += 1;
      if (this.sourceIndex >= this.sources.length) {
        this.sourceIndex = 0;
      }
      const delay = parseInt(this.delay);
      console.log('Wait ' + delay + 'ms before switching');
      setTimeout(() => {
        if (this.running) {
          this.load();
        }
      }, delay);
    }
  }
};
</script>

<style scoped lang="scss">

  @import "../style/color_";

  .page-debug {
    padding: 1rem;

    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .player {
    width: 400px;
    flex: 1 1 auto;
    max-width: 400px;
    margin: auto auto 0;
  }
</style>
